import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import RipplrLogo from 'assets/ripplr-logo.svg';
import Cartoon from 'assets/cartoon.png';
import { Box, Image, Flex, Text } from 'atoms';

export default function Landing() {
	const history = useHistory();

	useEffect(() => {
		setTimeout(() => {
			history.push('/login');
		}, 3000);
	}, [history]);

	return (
		<Flex flexDirection="column" alignItems="center">
			<Box py="1rem">
				<Image src={RipplrLogo} alt="Ripplr Logo" height={27} width={116} />
			</Box>
			<Box textAlign="center">
				<Text fontSize="26px" pt="1rem">
					Welcome to
				</Text>
				<Text fontSize="26px" fontWeight="700" pt="1rem">
					Sales Collection Module
				</Text>
			</Box>
			<Box py="3rem">
				<Image src={Cartoon} alt="Ripplr Cartoon" height={244} width={260} />
			</Box>
		</Flex>
	);
}
